module.exports = __webpack_public_path__ + "img/accounting-balance-sheet.d53d2b41.svg";